 
<template>
  <div class="fill-height"
    :style="[
      {'background-color': `#F4F4F4`} 
    ]"
  >
    <strategio-app-bar 
      :showTopPanel="false">
    </strategio-app-bar>
    
    <!-- <v-speed-dial
      id="options-button"
      fixed
      v-model="fab"
      bottom
      right
      direction="top"
      transition="scale-transition"
      elevation-6
      v-intro="'Desde aquí podrá marcar este reporte como favorito, ver la lista de reportes disponibles o regresar a la página de reportes'" 
      style = "left: ; top: "
      position = "absolute"
    > -->
    <!-- @mousedown="startDrag()" @mousemove="doDrag()" -->
      <!-- <v-btn
        id = "btnbackreport"
        slot="activator"
        fab
        hover
        x-large
        color="#2262C6"
        position = "absolute"
      > -->
      <!-- @click.ctrl="goBack(reportData.containedBy)" -->
        <!-- <v-icon color="white">arrow_back</v-icon>
      </v-btn>
    </v-speed-dial> -->
    
    <v-main style="height:100vh;">
      <div style="max-height:100%; overflow:auto">
        <div v-if="loading" class="loading-container" id="loadingContainer">
          <v-img class="loading-icon" :src="require('@/assets/loading/animacion_carga.gif')"></v-img>
        </div>
        <iframe v-if="!biCondition" v-show="!loading" class="strategio-iframe" :src="url" frameborder="0"></iframe>
        <div v-if="biCondition"  class="strategio-iframe" id="reportContainer"></div>
      </div>
    </v-main>
  </div>
</template>


<script>
/* eslint-disable */
import StrategioAppBar from '../components/header-bar/strategio-app-bar.vue'
import reportsStorage from '../storage/reportsStorage';
import * as pbi from 'powerbi-client';

export default {
  name: "show-report",
  data() {
    return {
      reportData: {
        url2: ""
      },
      url: "",
      currentLocation: this.$route.name,
      fab: false,
      drawer: false,
      containedByFolder: {},
      reportsInFolder: [],
      biCondition : true,
      initial_leftposition: 0,
      initial_topposition: 0,
      range_leftposition: 0,
      range_topposition: 0,
      dragging: false,
      x_ini: 0,
      y_ini: 0,
      x_fin: 0,
      y_fin: 0,
      moved: false,
      loading: true,
      showTopPanel: false
    };
  },
  components: {
    StrategioAppBar
  },
  beforeRouteUpdate(to, from, next) {
    // react to route changes...
    // don't forget to call next()
    this.loadFolders(to.params.reportID);
    // this.reportID = to.params.reportID
    next();
  },
  mounted() {
    this.loadFolders(this.$route.params.reportID);
    // this.reportID = this.$route.params.reportID

    window.addEventListener('mouseup', this.stopDrag);
    window.addEventListener('mousedown', this.startDrag);
    window.addEventListener('mousemove', this.doDrag);

    if (this.$route.query["main-page"]) {
      // console.log("main-page: ", this.$route.query["main-page"]);

      let intro = this.$intro();
      intro.setOptions({
        skipLabel: "Saltar",
        nextLabel: "Siguiente",
        prevLabel: "Previo",
        doneLabel: "Listo"
      });

      intro.start().oncomplete(() => {
        this.$router.push("/0");
      });
    }
  },
  methods: {
    download() {
      reportsStorage.registerView(this.reportData.reportID, "DOWNLOAD");
      this.url = this.reportData.url2;
    },
    setFavorite(report) {
      // TODO: Enviar al servidor :D
      this.reportData.isFavorite = !this.reportData.isFavorite;
      reportsStorage.setFavorite(report.itemID, this.reportData.isFavorite);
    },
    goToReport(report) {
      let _isFavorite = "";
      if (this.$route.params.isFavorite) {
        _isFavorite = "/1";
      }
      this.$router.push(`/show-report/${report.itemID}${_isFavorite}`);
    },
    goBack(containedBy) {
      if (this.$route.params.isFavorite) {
        this.$router.push("/user/favorites");
        return;
      }
      this.$router.push(`/${containedBy}`);
      this.currentLocation = this.$route.name;
    },
    openPanel() {
      this.drawer = !this.drawer;
    },
    loadFolders(reportID) { 
      this.loading = false
      reportsStorage.getData({
        folderID: "0",
        forceLoad: false,
        onSuccess: (data, store) => {
          const URL_KEY = window.s3_config_key_service;
          const report = reportsStorage.findItemByID(reportID);
          this.reportData = report;
          this.url = report.url1 + `/?key=${URL_KEY}&mail=${JSON.parse(localStorage.user).mail}`;

          if(report.url1.length <= 36 && (!report.hasOwnProperty('embedView') || report.embedView == 0)) {
              reportsStorage.getAccessToken(report.url1, (at) => {
                this.loadPowerBiFolder(report,at.accessToken)
              })
          } else {
            this.biCondition = false
          }

          if (this.$route.params.isFavorite) {
            this.containedByFolder = { itemName: "FAVORITOS" };
          } else {
            this.containedByFolder = reportsStorage.findItemByID(
              report.containedBy
            ) || { itemName: "REPORTES" };
          }

          if (this.$route.params.isFavorite) {
            const _favorites = [];
            store.map((item, index) => {
              if (item.isFavorite) {
                _favorites.push(item);
              }
            });
            this.reportsInFolder = _favorites;
          } else {
            this.reportsInFolder = reportsStorage.findItemsInFolder(
              report.containedBy,
              "REPORTS"
            );
          }
          reportsStorage.registerView(reportID, "VIEW");
        },
        onError: error => {
          this.messsage = "Error desconocido";
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data);
            // console.log(error.response.status);
            // console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            // console.log(error.request);
            this.messsage = "No pudimos obtener respuesta del servidor";
          } else {
            // Something happened in setting up the request that triggered an Error
            this.message = `Error desconocido: ${error.message}`;
          }
          this.snackbar = true;
          // console.log(error.config);
        }
      });
    },
    loadPowerBiFolder (reportConfig,at) {
      // Grab the reference to the div HTML element that will host the report.
      let reportContainer = document.getElementById('reportContainer')
      reportContainer.style = "width: 0px; height: 0px"

      this.loading = true
      // Report's Secured Token
      let paramTable = reportConfig.url3.trim()
      let paramColumn = reportConfig.url4.trim()
      let values = reportConfig.url5.split(",")
      let paraValues = Array.isArray(values) ? values.map(e => e.trim()) : [values.trim()]
      let rId = reportConfig.url1
      let accessToken = at

      // Embed URL
      const embedUrl = 'https://app.powerbi.com/reportEmbed?groupId=3ddccf9f-ba6a-4ce2-8f78-8a5e15cfb780'

      const filter = {
        $schema: "http://powerbi.com/product/schema#advanced",
        target: {
          table: paramTable,//parameter1
          column: paramColumn,//parameter2
        },
        operator: "In",
        values: paraValues,//parameter3
      };

      // Report ID
      const embedReportId = rId

      let models = pbi.models

      let config = {
        type: 'report',
        accessToken: accessToken,
        embedUrl: embedUrl,
        id: embedReportId,
        permissions: models.Permissions.All,
        settings: {
          filterPaneEnabled: false,
          navContentPaneEnabled: true,
        }
      };

      // Embed the report and display it within the div container.
      let powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      let report = powerbi.embed(reportContainer, config)

      // Report.off removes a given event handler if it exists.
      report.off('loaded')

      // Report.on will add an event handler which prints to Log window.
      report.on("loaded", function () {
        report.getFilters()
          .then(filters => {
              filters.push(filter);
              return report.setFilters(filters);
          });
      });

      report.on("rendered", function () {
        this.loading = false
        reportContainer.style = "width: 100%; height: 100%;"
      })
    },
    startDrag(event) {
      // console.log("Start Drag")
      
      this.x_ini = event.clientX;
      this.y_ini = event.clientY;
      // console.log("X ini:",this.x_ini," Y ini:",this.y_ini)
      
      var obj =  document.getElementById("options-button")
      this.initial_leftposition = obj.offsetLeft
      this.initial_topposition = obj.offsetTop
      // console.log("X div:",this.initial_leftposition," Y div:",this.initial_topposition)

      this.range_leftposition = this.initial_leftposition + 72
      this.range_topposition = this.initial_topposition + 72

      if (this.x_ini >= this.initial_leftposition && this.x_ini <= this.range_leftposition
        && this.y_ini >=this.initial_topposition && this.y_ini <= this.range_topposition
        && this.currentLocation == 'ShowReport') {
    
          this.dragging = true;
      
      }

      this.x_mov = this.x_ini - this.initial_leftposition
      this.y_mov = this.y_ini - this.initial_topposition
      // console.log("X diff:",this.x_mov," Y diff:",this.y_mov)
    },
    stopDrag(event) {
      // console.log("Stop Drag")
      this.dragging = false;
      this.x_fin = event.clientX;
      this.y_fin = event.clientY;

      if( this.x_ini == this.x_fin && this.y_ini == this.y_fin && this.currentLocation == 'ShowReport'){
        
        if (this.x_ini >= this.initial_leftposition && this.x_ini <= this.range_leftposition
        && this.y_ini >=this.initial_topposition && this.y_ini <= this.range_topposition) {
    
          this.goBack(this.reportData.containedBy)
    
        }

      }

      // console.log("X fin:",this.x_fin," Y fin:",this.y_fin)
      this.moved = false;
    },
    doDrag(event) {
      if (this.dragging) {
        // console.log("Dragging")
        this.x_fin = event.clientX;
        this.y_fin = event.clientY;
        
        // console.log("X mov:",this.x_fin," Y mov:",this.y_fin)

        var obj =  document.getElementById("options-button")
        var x_def = this.x_fin - this.x_mov
        var y_def = this.y_fin - this.y_mov
        obj.style.left = x_def+"px"
        obj.style.top = y_def+"px"
        
        // console.log("Offset Left:",obj.offsetLeft," Offset Top:",obj.offsetTop)

        this.moved = true;
      }
    }
  }
};
</script>

<style>
.loading-icon {
  margin-left: auto;
  margin-right: auto;
  top: 35%;
  width: 401px;
  height: 301px;
}

.loading-container {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: black;
  background-image: url("../assets/loading/animacion_background.jpg");
  background-size: cover;
}

.strategio-iframe {
  width: 100%;
  height: 100%;
  position: absolute;
}
.strategio-report-speed-dial {
  opacity: 0.5;
  position: absolute !important;
  z-index: 9;
}
.strategio-showreport-drawer-item-title {
  font-weight: 300;
  font-size: 16px;
}
.strategio-showreport-drawer-item-title-active {
  background-color: blue;
  color: white;
}
.new_position {
  left: var(--x) !important;
  top: var(--y) !important;
}
</style>




// WEBPACK FOOTER //
// src/routes/show-report.vue